




























import { FromStore } from "@abaco/web-common/src/app";
import { Component, Inject, Mixins } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../../index";
import ProjectProposalMixin from "../../mixins/ProjectProposal";

@Component
export default class ProjectProposal extends Mixins(ProjectProposalMixin) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @FromStore(MODULE_ID) isSignleSubject!: boolean;

    loading = true;
    showInfoModal = false;
    currentInfoMsg = "";

    async loadData() {
        this.loading = true;
        this.isSignleSubject = (await this.maltaModule.maltaApi.getSubjects()).isSingle();
        if (!this.currentSubject) {
            const [subj, err] = await this.maltaModule.maltaApi.getSubject(this.subjectId);
            if (err) {
                this.toast(this.i18n("subject-not-found").toString(), { type: "error" });
                this.$router.push({ name: "subjectList", replace: true });
                this.loading = false;
                return;
            } else if (subj) {
                this.currentSubject = subj;
            }
        }

        await this.reloadAPI();
        this.loading = false;
    }

    async reloadAPI(force = false, applicationId?: string) {
        // if route name is "project-proposal-new" the project proposal not exists.
        if (this.$route.name !== "project-proposal-new" || force) {
            const [project, err] = await this.maltaModule.projectProposalApi.getProjectProposal(
                this.subjectId,
                applicationId ?? this.applicationId
            );
            if (err) {
                if (err.response && err.response.status !== 401) {
                    this.toast(this.i18n("subject-not-found").toString(), { type: "error" });
                    this.$router.push({ name: "contractsList", replace: true, params: { id: this.subjectId } });
                }
            } else if (project) {
                this.currentContract = project;
            }
        }
    }

    async mounted() {
        await this.loadData();
    }

    showInfo(messages: string) {
        this.currentInfoMsg = messages;
        this.showInfoModal = true;
    }
}
